import { render, staticRenderFns } from "./OtherList.vue?vue&type=template&id=3f59f708&scoped=true&"
import script from "./OtherList.vue?vue&type=script&lang=js&"
export * from "./OtherList.vue?vue&type=script&lang=js&"
import style0 from "./OtherList.vue?vue&type=style&index=0&id=3f59f708&lang=scss&scoped=true&"
import style1 from "./OtherList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f59f708",
  null
  
)

export default component.exports